import moment from "moment";

export const matchParameters = (data, formData) => {
  let viewingOptions = {
    selected: [],
  };
  const textValues =
    localStorage.getItem("textValues") !== "undefined"
      ? JSON.parse(localStorage.getItem("textValues"))
      : {};
  for (let key in textValues) {
    textValues[key] = "";
  }
  let groupNotesFilters = {
    selected: [],
    textValues: textValues,
  };
  let groupNotesOptions = [];
  let advancedEditingTools = {
    selected: [],
  };
  let mapOptions = {};
  let filters = {};
  data.map((item) => {
    let switchCaseView = "";
    let switchCaseGN = "";
    if (
      item.CriteriaName.includes("viewmulti") ||
      item.CriteriaName.includes("viewmany") ||
      item.CriteriaName.includes("viewblog") ||
      item.CriteriaName.includes("viewdocs") ||
      item.CriteriaName.includes("viewdate") ||
      item.CriteriaName.includes("viewsmalltext") ||
      item.CriteriaName.includes("viewlargetext") ||
      item.CriteriaName.includes("viewdaterange")
    ) {
      switchCaseView = item.CriteriaName;
    }
    if (
      !item.CriteriaName.includes("view") &&
      (item.CriteriaName.includes("multi") ||
        item.CriteriaName.includes("many") ||
        item.CriteriaName.includes("blog") ||
        item.CriteriaName.includes("docs") ||
        item.CriteriaName.includes("date") ||
        item.CriteriaName.includes("smalltext") ||
        item.CriteriaName.includes("largetext") ||
        item.CriteriaName.includes("daterange"))
    ) {
      switchCaseGN = item.CriteriaName;
    }
    switch (item.CriteriaName) {
      // parameters for viewing options drop down
      case "histlist":
        const value =
          item.CriteriaValue[0] === "viewhistory"
            ? "History by Line"
            : item.CriteriaValue[0] === "viewshorthistory"
            ? "Short History"
            : "Last Action";
        viewingOptions.historyRadioButton = value;
        return viewingOptions;
      case "howmany":
        viewingOptions.howmany = item.CriteriaValue[0];
        return viewingOptions;
      case "viewcitation":
      case "viewcontact":
      case "viewcontactinfo":
      case "viewcreator":
      case "viewdoctype":
      case "viewemailalert":
      case "viewemailit":
      case "viewfutureaction":
      case "viewhearings":
      case "viewhistory":
      case "viewintrodate":
      case "viewkeydates":
      case "viewlegisstatebackdrop":
      case "viewlinks":
      case "viewmeetingdate":
      case "viewotherlinks":
      case "viewpersonalnotes":
      case "viewpersreports":
      case "viewprogress":
      case "viewremarks":
      case "viewsearchcriteria":
      case "viewsession":
      case "viewsponsor":
      case "viewsubject":
      case "viewsummary":
      case "viewscore":
      case "viewhits":
        viewingOptions.selected = [
          ...viewingOptions.selected,
          item.CriteriaName,
        ];
        return viewingOptions;

      // parameters for group notes drop down
      case "editnotes":
      case "viewnoteslastupdated":
        groupNotesOptions = [...groupNotesOptions, item.CriteriaName];
        return groupNotesOptions;
      case switchCaseView:
        groupNotesOptions = [...groupNotesOptions, switchCaseView];
        return groupNotesOptions;
      default:
        break;

      // parameters for report format drop down
      case "mapit":
        mapOptions.mapit = item.CriteriaValue;
        return mapOptions;
      case "outformat":
        mapOptions.outformat =
          item.CriteriaValue[0] === "json" ? "html" : item.CriteriaValue[0];
        return mapOptions;
      case "maphidetopbanner":
      case "maphidereportname":
      case "maphidetotalbillslink":
      case "maphidefoundbillslegend":
      case "maphidebottomcounts":
        mapOptions.selectedAdvancedOptions =
          mapOptions.selectedAdvancedOptions.push(item.CriteriaName);
        return mapOptions;
      case "usefoundbillscolor":
        mapOptions.selected = ["usefoundBillscolor"];
        return mapOptions;
      case "lowcountcolor":
      case "medcountcolor":
      case "highcountcolor":
      case "foundbillscolor":
        mapOptions[item.CriteriaName] = `#${item.CriteriaValue}`;
        return mapOptions;

      // parameters for advanced editing tools drop down
      case "deleterecords":
      case "editsubjects":
      case "gridout":
      case "shortstate":
      case "addtotracking":
      case "multiaddtracking":
        advancedEditingTools.selected = [
          ...advancedEditingTools.selected,
          item.CriteriaName,
        ];
        return advancedEditingTools;
      case "sortheader":
        advancedEditingTools.sortheader = true;
        return advancedEditingTools;
      case "sort1":
      case "sort2":
      case "sort3":
      case "sort4":
        advancedEditingTools[item.CriteriaName] = item.CriteriaValue;
        return advancedEditingTools;

      // filter parameters for legis, regs, local tracks
      case "actiondateend":
      case "actiondatestart":
      case "archive":
      case "archivedsubjects":
      case "billnumbers":
      case "billtype":
      case "carry":
      case "citation":
      case "commentsdateend":
      case "commentsdatestart":
      case "hearingdateend":
      case "hearingdatestart":
      case "hearings":
      case "history":
      case "introdateend":
      case "introdatestart":
      case "meetingdateend":
      case "meetingdatestart":
      case "noteslastupdateend":
      case "noteslastupdatestart":
      case "noteslogic":
      case "notinpersonalreport":
      case "personalnotes":
      case "personalnotesend":
      case "personalnotesstart":
      case "personalreport":
      case "progress":
      case "recorddatestart":
      case "recorddateend":
      case "reporttitle":
      case "reporttype":
      case "sponsor":
      case "states":
      case "summary":
      case "title":
      case "moddateend":
      case "moddatestart":
      case "createdatestart":
      case "createdateend":
        filters[item.CriteriaName] = item.CriteriaValue.includes(",")
          ? item.CriteriaValue.split(",").map((item) => item.trim())
          : item.CriteriaValue;
        return filters;
      case "subjects":
        filters[item.CriteriaName] = item.CriteriaValue.includes(",")
          ? item.CriteriaValue.split(",").map((item) => item.trim())
          : item.CriteriaValue.length === 1 && item.CriteriaValue[0] === "0"
          ? []
          : item.CriteriaValue;
        return filters;
      case "regcreator":
      case "regtype":
        filters[item.CriteriaName] =
          item.CriteriaValue.length === 1 && item.CriteriaValue.includes("any")
            ? []
            : item.CriteriaValue.includes(",")
            ? item.CriteriaValue.split(",").map((item) => item.trim())
            : item.CriteriaValue;
        return filters;

      // group notes reporting filters
      case "noteslastupdateunassigned":
        groupNotesFilters.selected = [
          ...groupNotesFilters.selected,
          "noteslastupdateunassigned",
        ];
        return groupNotesFilters;
      case switchCaseGN:
        if (!switchCaseGN.includes("unassigned")) {
          groupNotesFilters.selected = [
            ...groupNotesFilters.selected,
            ...item.CriteriaValue.map((item) => parseInt(item)),
          ];
        } else {
          let unassignedCriteria = data.filter(
            (el) => el.CriteriaName === switchCaseGN
          )[0].CriteriaName;
          formData.map((e) => {
            if (e.Name === unassignedCriteria.split("unassigned")[0]) {
              groupNotesFilters.selected = [
                ...groupNotesFilters.selected,
                `${e.ClientFieldId}-1`,
              ];
            }
          });
        }
        if (switchCaseGN.includes("docs")) {
          groupNotesFilters.textValues[switchCaseGN] = item.CriteriaValue[0];
        }
        return groupNotesFilters;

      // parameters for bill finder
      case "request":
      case "maxFiles":
      case "fuzziness":
        filters[item.CriteriaName] = item.CriteriaValue[0];
        return filters;
    }
  });
  return {
    viewingOptions: viewingOptions,
    groupNotesOptions: groupNotesOptions,
    advancedEditingTools: advancedEditingTools,
    mapOptions: mapOptions,
    filters: filters,
    groupNotesFilters: groupNotesFilters,
  };
};

export const sortAlphabetical = (list, parameter) => {
  if (!list) {
    return [];
  }

  return list.sort(function (a, b) {
    if (a[parameter] < b[parameter]) {
      return -1;
    }
    if (a[parameter] > b[parameter]) {
      return 1;
    }
    return 0;
  });
};

export const sortByDate = (list, parameter) => {
  return list.sort(function (a, b) {
    return new Date(a[parameter]) - new Date(b[parameter]);
  });
};
export const sortBySort = (list, parameter) => {
  return list.sort(function (a, b) {
    return a[parameter] - b[parameter];
  });
};

export const filterRegions = (data, regionCode) => {
  let newOrderedList = [];
  let additionalTerritories = [];
  if (!regionCode) {
    data.map((item) => {
      switch (item.RegionType) {
        case "territory":
          return additionalTerritories.push(item);
        case "special":
          if (item.Name !== "US Federal") {
            return newOrderedList.push(item);
          } else {
            return additionalTerritories.push(item);
          }
        default:
          return newOrderedList.push(item);
      }
    });
    newOrderedList = sortAlphabetical(newOrderedList, "Name");
    additionalTerritories = sortAlphabetical(additionalTerritories, "Name");
  } else {
    data.map((item) => {
      switch (item.value) {
        case "PR":
        case "US":
        case "VI":
        case "GU":
          return additionalTerritories.push(item);
        default:
          return newOrderedList.push(item);
      }
    });
    newOrderedList = sortAlphabetical(newOrderedList, "value");
    additionalTerritories = sortAlphabetical(additionalTerritories, "value");
  }
  return [...newOrderedList, ...additionalTerritories];
};

export const returnDateFormat = (string) => {
  if (string) {
    return moment(string).format("MMM / DD / YYYY");
  } else return " ";
};

export const sortFieldList = (list) => {
  return list.sort(function (a, b) {
    return a.SortOrder - b.SortOrder;
  });
};

export const mapGroupNotesOptionsValues = (optionsData) => {
  let sortedOptions = {};
  optionsData.forEach((item) => {
    if (!sortedOptions[item.ClientFieldId]) {
      sortedOptions[item.ClientFieldId] = [];
    }
    sortedOptions[item.ClientFieldId].push({
      id: item.Value,
      name: item.Name,
      value: item.Value,
      parent: item.ClientFieldId,
    });
  });
  return sortedOptions;
};

export const returnTextValuesForClearedFilters = () => {
  const textValues = JSON.parse(localStorage.getItem("textValues"));
  Object.entries(textValues)
    .map((item) => {
      if (item[1] !== "") {
        return item[0];
      }
    })
    .filter((item) => item !== undefined);
  return textValues;
};

export const mapGroupNotesFieldList = (fieldListData) => {
  let textValues = {};
  let radio = {};
  let dateTime = {};
  fieldListData.forEach((item) => {
    switch (item.DisplayType) {
      case "Blog":
        textValues[item.Name] = "";
        break;
      case "Date":
        dateTime[`${item.Name}start`] = " ";
        dateTime[`${item.Name}end`] = " ";
        break;
      case "select":
        radio[item.Name] = "";
    }
  });
  return { textValues, dateTime, radio };
};

export const mapGlobalPermissions = (data) => {
  let permissions = {};
  data.forEach((item) => {
    switch (item) {
      case "Legis: View Group Notes":
      case "Regs: View Group Notes":
      case "Local: View Group Notes":
        permissions.viewGroupNotes = true;
        return permissions;
      case "Legis: Edit Group Notes":
      case "Regs: Edit Group Notes":
      case "Local: Edit Group Notes":
        permissions.editGroupNotes = true;
        return permissions;
      case "Legis: Edit Subjects":
      case "Regs: Edit Subjects":
      case "Local: Edit Subjects":
        permissions.editSubject = true;
        return permissions;
    }
  });
  return permissions;
};

export const validUrl = (str) => {
  var regex =
    /(http|https):\/\/(\w+:{0,1}\w*)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%!\-/]))?/;
  if (!regex.test(str)) {
    return false;
  } else {
    return true;
  }
};

export const updateArrows = (type) => {
  const navigationArrows = document.querySelectorAll(".record-arrow");
  for (let i = 0; i <= navigationArrows.length - 1; i++) {
    navigationArrows[i].classList[type]("red");
  }
};
export const getUniqueListBy = (arr, key) => {
  console.log(arr, key, 123213213213);
  return [...new Map(arr.map((item) => [item[key], item])).values()];
};

export const getFilterOptions = (filter) => {
  const searchValues = filter.SearchValue ? JSON.parse(filter.SearchValue) : [];

  const options = searchValues.map((seachValue) => {
    return {
      label: seachValue.Display,
      value: seachValue.Value,
      default: seachValue.DefaultSelect,
    };
  });

  return options;
};

export const populateSortAndSearchParams = (query) => {
  const sortParameters = {};
  const sortDirections = {};
  const parametersSectionSelectables = {};
  let filterFields = [];
  let sortFields = [];

  if (query) {
    filterFields = sortAlphabetical(
      query.QueryParameters.filter((item) => item.DefaultSearch),
      "SearchSequence"
    );

    if (filterFields) {
      filterFields
        .filter((field) => field.DataType === "dropdown")
        .forEach((filter) => {
          const filterOptions = getFilterOptions(filter);
          if (filterOptions) {
            const defaultOption = filterOptions.find((value) => value.default);
            parametersSectionSelectables[filter.ParameterDescription] =
              defaultOption ? defaultOption.value : undefined;
          }
        });
    }

    sortFields = sortAlphabetical(
      query.QueryParameters.filter((queryParam) => queryParam.DefaultSort),
      "SortSequence"
    );

    if (sortFields) {
      sortFields.forEach((field, index) => {
        sortParameters[index] = field.QueryParameterId;
        sortDirections[index] = field.Direction;
      });
    }
  }

  return {
    parametersSectionSelectables,
    sortParameters,
    sortFields,
    sortDirections,
    filterFields,
  };
};



// WEBPACK FOOTER //
// ./src/store/reducers/helpers.js